import React from 'react';
import {AppText, AppSectionTitle} from '../../../../Presentation/components/ui/Typography';
import {PermissionSelector} from './PermissionSelector';

interface PermissionsContentProps {
  permissionsLoading: boolean;
  loadingRolePermissions: boolean;
  permissionsByCategory: Record<string, any[]>;
  selectedPermissions: number[];
  onPermissionToggle: (permissionId: number) => void;
  onSelectAll: (permissions: any[]) => void;
  onDeselectAll: () => void;
  onDeselectCategory?: (categoryPermissions: any[]) => void;
  getResourceDisplayName: (resource: string) => string;
  getActionDisplayName: (action: string) => string;
}

/**
 * Reusable component for permissions content
 */
export const PermissionsContent: React.FC<PermissionsContentProps> = ({
  permissionsLoading,
  loadingRolePermissions,
  permissionsByCategory,
  selectedPermissions,
  onPermissionToggle,
  onSelectAll,
  onDeselectAll,
  onDeselectCategory,
  getResourceDisplayName,
  getActionDisplayName
}) => {
  if (permissionsLoading || loadingRolePermissions) {
    return (
      <div className="text-center py-12">
        <AppSectionTitle className="text-gray-500">
          {loadingRolePermissions ? 'جاري تحميل صلاحيات الدور...' : 'جاري تحميل الصلاحيات...'}
        </AppSectionTitle>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {Object.entries(permissionsByCategory).map(([category, permissions]) => (
        <PermissionSelector
          key={category}
          permissions={permissions}
          selectedPermissions={selectedPermissions}
          onPermissionToggle={onPermissionToggle}
          onSelectAll={() => onSelectAll(permissions)}
          onDeselectAll={onDeselectAll}
          onDeselectCategory={onDeselectCategory}
          getResourceDisplayName={getResourceDisplayName}
          getActionDisplayName={getActionDisplayName}
          category={category}
          loading={permissionsLoading}
        />
      ))}
    </div>
  );
};
